import React, { useState } from 'react';

const CalendlyButton = ({ className = '' }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={`rounded-full px-4 sm:px-5 py-2 text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 transition ${className}`}
      >
        Prendre rendez-vous
      </button>

      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white w-[90%] max-w-3xl rounded-lg shadow-lg relative">
            <button
              onClick={() => setOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-black text-xl"
              aria-label="Fermer"
            >
              &times;
            </button>
            <iframe
              src="https://calendly.com/amplifymycom-9htq/30min"
              width="100%"
              height="600"
              frameBorder="0"
              allow="camera; microphone; fullscreen"
              title="Calendly"
              className="rounded-b-lg"
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default CalendlyButton;
